<template>
  <v-container class="py-0 px-0 px-md-4" fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12" md="3" class="d-flex align-center">
                <v-text-field
                  v-model="search"
                  label="Consulta"
                  prepend-inner-icon="search"
                  @keydown.enter.prevent="doSearch"
                  tabindex="1"
                  flat
                  outlined
                  hide-details
                  clearable
                  dense
                  autofocus
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="8">
                <v-row no-gutters>
                  <v-col cols="12" md="4">
                    <v-menu
                      v-model="searchDatesMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      min-width="240px"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="searchDateRangeText"
                          label="Rango de Fechas"
                          prepend-inner-icon="event"
                          tabindex="2"
                          flat
                          outlined
                          hide-details
                          clearable
                          readonly
                          dense
                          v-bind="attrs"
                          v-on="on"
                          @click:clear="
                            searchDatesMenu = false;
                            searchDates = [];
                          "
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="searchDates" no-title range>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="
                            searchDatesMenu = false;
                            searchDates = [];
                          "
                          >Cancel</v-btn
                        >
                        <v-btn
                          text
                          color="primary"
                          @click="
                            searchDatesMenu = false;
                            doSearch();
                          "
                          >OK</v-btn
                        >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="4" class="d-flex align-center">
                    <v-select
                      v-model="departamento"
                      :items="departamentos"
                      placeholder="Departamento"
                      tabindex="3"
                      clearable
                      outlined
                      dense
                      hide-details
                      class="text-capitalize"
                      @change="doSearch"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="4" class="d-flex align-center">
                    <v-autocomplete
                      v-model="derecho"
                      :items="derechos"
                      placeholder="Derecho"
                      tabindex="4"
                      clearable
                      outlined
                      dense
                      hide-details
                      class="text-capitalize"
                      @change="doSearch"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="1" class="d-flex align-center">
                <v-btn color="primary" @click.prevent="doSearch" block>
                  <v-icon size="18" left>search</v-icon>
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card class="px-2">
          <v-row>
            <v-col cols="12" md="6">
              <div id="map" :style="{ height: `${clientHeight * 0.45}px` }" />
              <v-row>
                <v-col cols="12">
                  <apexchart
                    type="line"
                    :options="datetimeOptions"
                    :series="datetimeSeries"
                  ></apexchart>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="6">
              <div v-if="derechosOptions">
                <apexchart
                  :height="`${clientHeight * 0.3}px`"
                  type="bar"
                  :options="derechosOptions"
                  :series="derechosSeries"
                ></apexchart>
              </div>
              <div v-if="derechosOptions">
                <apexchart
                  :height="`${clientHeight * 0.3}px`"
                  type="bar"
                  :options="accionadosOptions"
                  :series="accionadosSeries"
                ></apexchart>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text
            :style="{
              'overflow-y': 'scroll',
              'max-height': `${clientHeight * 0.18}px`,
            }"
          >
            <div v-for="h in responseData.hits.hits" :key="h._id">
              <tutela-result :tutela="h._source" />
              <v-divider />
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>



<script>
const DERECHOS = {
  "Acceso A La Administración De Justicia":
    "acceso_a_la_administracion_de_justicia",
  "Agua Potable": "agua_potable",
  "Ambiente Sano": "ambiente_sano",
  "Asociación Sindical": "asociacion_sindical",
  "Ayuda Humanitaria": "ayuda_humanitaria",
  "Consulta Previa": "consulta_previa",
  "Debido Proceso": "debido_proceso",
  "Derecho A La Honra": "derecho_a_la_honra",
  "Derecho A La Paz": "derecho_a_la_paz",
  "Derecho A La Reparación A Población Víctima De Desplazamiento":
    "derecho_a_la_reparacion_a_poblacion_victima_de_desplazamiento",
  "Derecho A Morir Dignamente": "derecho_a_morir_dignamente",
  "Derecho Al Buen Nombre": "derecho_al_buen_nombre",
  "Derecho De Petición": "derecho_de_peticion",
  "Dignidad Humana": "dignidad_humana",
  Educación: "educacion",
  "Elegir Y Ser Elegido": "elegir_y_ser_elegido",
  "Estabilidad Laboral Reforzada": "estabilidad_laboral_reforzada",
  Familia: "familia",
  "Habeas Data": "habeas_data",
  "Identidad Cultural": "identidad_cultural",
  "Identidad Sexual Y De Genero": "identidad_sexual_y_de_genero",
  Igualdad: "igualdad",
  "Integridad Personal, Fisica Y Psicologica":
    "integridad_personal,_fisica_y_psicologica",
  "Interrupción Voluntaria Del Embarazo":
    "interrupcion_voluntaria_del_embarazo",
  Intimidad: "intimidad",
  "Intimidad Familiar": "intimidad_familiar",
  Libertad: "libertad",
  "Libertad De Culto": "libertad_de_culto",
  "Libertad De Enseñanza": "libertad_de_ensenanza",
  "Libertad De Expresión": "libertad_de_expresion",
  "Libertad De Información": "libertad_de_informacion",
  "Libertad De Locomoción Y Domicilio": "libertad_de_locomocion_y_domicilio",
  "Libertad De Opinión": "libertad_de_opinion",
  "Libertad De Prensa": "libertad_de_prensa",
  "Libertad De Profesión U Oficio": "libertad_de_profesion_u_oficio",
  "Libre Desarrollo De La Personalidad": "libre_desarrollo_de_la_personalidad",
  "Mínimo Vital": "minimo_vital",
  "Objeción De Conciencia": "objecion_de_conciencia",
  "Participación Política": "participacion_politica",
  "Personalidad Jurídica": "personalidad_juridica",
  "Propiedad Privada": "propiedad_privada",
  "Recreación Y Deporte": "recreacion_y_deporte",
  Salud: "salud",
  "Seguridad Personal": "seguridad_personal",
  "Seguridad Social": "seguridad_social",
  "Sexuales Y Reproductivos": "sexuales_y_reproductivos",
  "Sin Derecho": "sin_derecho",
  "Suministro De Energía Eléctrica": "suministro_de_energia_electrica",
  Trabajo: "trabajo",
  "Tranquilidad Personal": "tranquilidad_personal",
  Vida: "vida",
  "Visita Conyugal": "visita_conyugal",
  "Vivienda Digna": "vivienda_digna",
  "Acceso A La Administración De Justicia":
    "acceso_a_la_administracion_de_justicia",
  "Agua Potable": "agua_potable",
  "Ambiente Sano": "ambiente_sano",
  "Asociación Sindical": "asociacion_sindical",
  "Ayuda Humanitaria": "ayuda_humanitaria",
  "Consulta Previa": "consulta_previa",
  "Debido Proceso": "debido_proceso",
  "Derecho A La Honra": "derecho_a_la_honra",
  "Derecho A La Paz": "derecho_a_la_paz",
  "Derecho A La Reparación A Población Víctima De Desplazamiento":
    "derecho_a_la_reparacion_a_poblacion_victima_de_desplazamiento",
  "Derecho A Morir Dignamente": "derecho_a_morir_dignamente",
  "Derecho Al Buen Nombre": "derecho_al_buen_nombre",
  "Derecho De Petición": "derecho_de_peticion",
  "Dignidad Humana": "dignidad_humana",
  Educación: "educacion",
  "Elegir Y Ser Elegido": "elegir_y_ser_elegido",
  "Estabilidad Laboral Reforzada": "estabilidad_laboral_reforzada",
  Familia: "familia",
  "Habeas Data": "habeas_data",
  "Identidad Cultural": "identidad_cultural",
  "Identidad Sexual Y De Genero": "identidad_sexual_y_de_genero",
  Igualdad: "igualdad",
  "Integridad Personal, Fisica Y Psicologica":
    "integridad_personal,_fisica_y_psicologica",
  Intimidad: "intimidad",
  "Intimidad Familiar": "intimidad_familiar",
  Libertad: "libertad",
  "Libertad De Culto": "libertad_de_culto",
  "Libertad De Enseñanza": "libertad_de_ensenanza",
  "Libertad De Expresión": "libertad_de_expresion",
  "Libertad De Información": "libertad_de_informacion",
  "Libertad De Locomoción Y Domicilio": "libertad_de_locomocion_y_domicilio",
  "Libertad De Opinión": "libertad_de_opinion",
  "Libertad De Prensa": "libertad_de_prensa",
  "Libertad De Profesión U Oficio": "libertad_de_profesion_u_oficio",
  "Libre Desarrollo De La Personalidad": "libre_desarrollo_de_la_personalidad",
  "Mínimo Vital": "minimo_vital",
  "Objeción De Conciencia": "objecion_de_conciencia",
  "Participación Política": "participacion_politica",
  "Personalidad Jurídica": "personalidad_juridica",
  "Propiedad Privada": "propiedad_privada",
  "Recreación Y Deporte": "recreacion_y_deporte",
  Salud: "salud",
  "Seguridad Personal": "seguridad_personal",
  "Seguridad Social": "seguridad_social",
  "Sexuales Y Reproductivos": "sexuales_y_reproductivos",
  "Sin Derecho": "sin_derecho",
  "Suministro De Energía Eléctrica": "suministro_de_energia_electrica",
  "Superintendencia Nacional De Salud": "superintendencia_nacional_de_salud",
  Trabajo: "trabajo",
  "Tranquilidad Personal": "tranquilidad_personal",
  Vida: "vida",
  "Visita Conyugal": "visita_conyugal",
  "Vivienda Digna": "vivienda_digna",
};

const APEX_BAR_OPTIONS = {
  legend: {
    show: false,
  },
  chart: {
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    bar: {
      barHeight: "100%",
      distributed: true,
      horizontal: true,
      dataLabels: {
        position: "bottom",
      },
    },
  },
  colors: [
    "#33b2df",
    "#546E7A",
    "#d4526e",
    "#13d8aa",
    "#A5978B",
    "#2b908f",
    "#f9a3a4",
    "#90ee7e",
    "#f48024",
    "#69d2e7",
  ],
  dataLabels: {
    enabled: true,
    textAnchor: "start",
    style: {
      colors: ["#fff"],
    },
    formatter: function (val, opt) {
      return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val;
    },
    offsetX: 0,
    dropShadow: {
      enabled: true,
    },
  },
  stroke: {
    width: 1,
    colors: ["#fff"],
  },
  yaxis: {
    labels: {
      show: false,
    },
  },
  tooltip: {
    theme: "dark",
    x: {
      show: false,
    },
    y: {
      title: {
        formatter: function () {
          return "";
        },
      },
    },
  },
};
/*
  global jQuery
*/
window.jQuery = require("jquery");
require("jvectormap");
require("@/lib/jquery-jvectormap-co-mill.js");
import _startcase from "lodash.startcase";
import _merge from "lodash.merge";
import _invert from "lodash.invert";
import TutelaResult from "./TutelaResult.vue";

import { COLOMBIA_STATES } from "@/commons/constants.js";
import { findColombiaStateCode } from "@/commons/util.js";

const COLOMBIA_STATES_REV = _invert(COLOMBIA_STATES);
console.log(COLOMBIA_STATES_REV);
const DERECHOS_REV = _invert(DERECHOS);
console.log(DERECHOS_REV);

export default {
  data() {
    return {
      search: "",
      searchDates: [],
      searchDatesMenu: false,
      derecho: "",
      derechos: Object.keys(DERECHOS).map((key) => {
        return {
          text: key,
          value: DERECHOS[key],
        };
      }),
      departamento: "",
      departamentos: Object.keys(COLOMBIA_STATES).map((key) => {
        return {
          text: key,
          value: COLOMBIA_STATES[key],
        };
      }),
      municipio: "",
      municipios: [],
      mapContainer: undefined,
      status: "",
      responseData: {
        aggregations: {
          accionados: {
            buckets: [],
          },
          derechos: {
            buckets: [],
          },
          tutelas_activity: {
            buckets: [],
          },
        },
        hits: {
          hits: [],
        },
      },
      loading: true,
      clientHeight: 1080,
    };
  },
  components: {
    TutelaResult,
  },
  mounted() {
    this.doSearch();
    this.clientHeight = document.documentElement.clientHeight;
  },
  methods: {
    doSearch() {
      let searchRequest = {
        consulta: this.search,
        departamento: this.departamento,
        derecho: this.derecho,
        municipio: this.municipio,
        fechaInicio: this.searchDates[0],
        fechaFin: this.searchDates[1],
      };
      console.log("searchRequest", searchRequest);
      this.$http.post(`/api/tutelas`, searchRequest).then((response) => {
        console.log("searchResponse", response);
        if (response.data.status == "no-data") {
          this.status = "no-data";
          return;
        }
        this.responseData = response.data;
        this.drawMap(response.data);
      });
    },
    drawMap(responseData) {
      console.log("drawMap");
      let regions = {};
      responseData?.aggregations?.departamentos?.buckets?.forEach((item) => {
        let code = findColombiaStateCode(item.key);
        if (code) {
          regions[code] = item.doc_count;
        }
      });
      const selector = "#map";
      this.mapContainer = jQuery(selector);
      this.mapContainer.empty();

      this.mapContainer.vectorMap({
        map: "co_mill",
        backgroundColor: "transparent",
        zoomOnScroll: false,
        zoomOnButtons: false,
        regionStyle: {
          initial: {
            fill: "#e4e4e4",
            "fill-opacity": 0.9,
            stroke: "none",
            "stroke-width": 0,
            "stroke-opacity": 0,
          },
        },
        series: {
          regions: [
            {
              values: regions,
              scale: ["#C8EEFF", "#00739e"],
              normalizeFunction: "polynomial",
            },
          ],
        },
        onRegionTipShow: function (e, el, code) {
          if (regions.hasOwnProperty(code)) {
            el.html(el.html() + " - " + regions[code]);
          } else {
            el.html(el.html());
          }
        },
      });
    },
    clearDateSearch() {},
    sortDateRange(dateRange) {
      if (dateRange.length == 2) {
        let date1 = new Date(dateRange[0]);
        let date2 = new Date(dateRange[1]);
        if (date1 < date2) {
          return dateRange;
        } else {
          return [dateRange[1], dateRange[0]];
        }
      }
    },
  },
  computed: {
    searchDateRangeText: {
      get: function () {
        if (!!this.searchDates && this.searchDates.length == 2) {
          return this.sortDateRange(this.searchDates).join(" ~ ");
        }
        return "";
      },
      set: function (newValue) {
        console.log(newValue);
      },
    },
    derechosOptions() {
      let categories = this.responseData?.aggregations?.derechos?.buckets.map(
        (item) => _startcase(item.key)
      );
      let localOptions = {
        title: {
          text: "Derechos",
          align: "center",
          floating: true,
        },
        xaxis: {
          categories: categories ? categories : [],
        },
      };
      return _merge({}, APEX_BAR_OPTIONS, localOptions);
    },
    derechosSeries() {
      let series = this.responseData?.aggregations?.derechos?.buckets.map(
        (item) => item.doc_count
      );
      if (series) {
        return [{ data: series }];
      }
      return [];
    },
    accionadosOptions() {
      let categories = this.responseData?.aggregations?.accionados?.buckets.map(
        (item) => _startcase(item.key)
      );
      let localOptions = {
        title: {
          text: "Accionados",
          align: "center",
          floating: true,
        },
        xaxis: {
          categories: categories ? categories : [],
        },
        colors: [
          "#903250",
          "#133C65",
          "#7C6A6A",
          "#6F7AB7",
          "#BBD4CE",
          "#FFCB00",
          "#072448",
          "#EDAE49",
          "#127A79",
          "#D9E3FF",
        ],
      };
      return _merge({}, APEX_BAR_OPTIONS, localOptions);
    },
    accionadosSeries() {
      let series = this.responseData?.aggregations?.accionados?.buckets.map(
        (item) => item.doc_count
      );
      if (series) {
        return [{ data: series }];
      }
      return [];
    },
    datetimeOptions() {
      return {
        chart: {
          height: 200,
          type: "line",
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        title: {
          text: "Línea de Tiempo",
          align: "left",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories:
            this.responseData?.aggregations?.tutelas_activity?.buckets.map(
              (item) => item.key_as_string.split(" ")[0]
            ),
          type: "datetime",
          tickAmount: 10,
          labels: {
            datetimeFormatter: {
              year: "yyyy",
              month: "MMM - yyyy",
              day: "dd MMM",
              hour: "HH:mm",
            },
          },
        },
      };
    },
    datetimeSeries() {
      return [
        {
          name: "Tutelas",
          data: this.responseData?.aggregations?.tutelas_activity?.buckets.map(
            (item) => item.doc_count
          ),
        },
      ];
    },
  },
};
</script>

<style>
.jvectormap-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  touch-action: none;
}

.jvectormap-tip {
  position: absolute;
  display: none;
  border: solid 1px #cdcdcd;
  border-radius: 3px;
  background: #fff;
  color: #888;
  font-family: sans-serif, Verdana;
  font-size: smaller;
  padding: 3px;
  z-index: 20;
}
.jvectormap-label {
  position: absolute;
  display: none;
  border: solid 1px #cdcdcd;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  background: #292929;
  color: white;
  font-family: sans-serif, Verdana;
  font-size: smaller;
  padding: 3px;
  z-index: 11;
}
</style>